import React from 'react';
import {
  AutocompleteArrayInput,
  Edit as RaEdit,
  ReferenceArrayInput,
  ReferenceInput,
  required,
  SelectInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

const Edit: React.FC = (props) => (
  <RaEdit {...props}>
    <SimpleForm redirect="show">
      <TextInput source="suggest_type" />
      <ReferenceInput
        source="series_id"
        reference="series"
        validate={[required()]}
      >
        <SelectInput optionText="title" />
      </ReferenceInput>
      <ReferenceArrayInput source="movie_suggests" reference="movie" fullWidth>
        <AutocompleteArrayInput optionText="title" />
      </ReferenceArrayInput>
      <ReferenceArrayInput
        source="series_suggests"
        reference="series"
        fullWidth
      >
        <AutocompleteArrayInput optionText="title" />
      </ReferenceArrayInput>
    </SimpleForm>
  </RaEdit>
);

export default Edit;
